/*******************************************************************************
TRIGGER CLEAR INPUT BOX
Triggers clearing the input box.
*******************************************************************************/

import clearInputBox from './clear';

export default function triggerClearInputBox(e) {
    const $input = $(e.currentTarget).prev('input');
    clearInputBox($input);
}
